
import {createContext, useState} from 'react'

const Context = createContext()

export const DepartamentContextProvider = ({children}) => {
 const [allDepartaments, setAllDepartaments] = useState([])
 const [departaments, setDepartaments] = useState([]);
 const [departament, setDepartament] = useState({})
 const [loading, setLoading] = useState(false);
 const [message, setMessage] = useState({
  message: '',
  status: 200
 })


 return <Context.Provider value={{allDepartaments, setAllDepartaments, departaments, setDepartaments, departament, setDepartament, message, setMessage, loading, setLoading}}>
  {children}
 </Context.Provider>
}
export default Context